<mat-accordion>

    <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Material
            </mat-panel-title>
        </mat-expansion-panel-header>

        <cadastrar-materiais #cadastrarMateriais [planejamentoOficina]="planejamentoOficina">
        </cadastrar-materiais>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="listarMateriais.carregarLista()"
        (closed)="openFormCadastro = true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Lista de Materiais ( {{planejamentoOficina.materiaisPlanejamentosOficinas?.length}} )
            </mat-panel-title>
        </mat-expansion-panel-header>

        <listar-materiais #listarMateriais
                          [materiaisPlanejamentosOficinas]="planejamentoOficina.materiaisPlanejamentosOficinas"
                          (onAtualizarMaterial)="onGetAdicionar($event); cadastrarMateriais.atualizarMaterial($event)"
                          (onAdicionar)="onGetAdicionar($event); cadastrarMateriais.cancelar()">
        </listar-materiais>

    </mat-expansion-panel>


</mat-accordion>
